import styled from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';
import { SectionTitle, Text } from '../../../../components';

/** The whole inline form inside its Panel: header (title + price banner), fields, footer. */
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[20]};
`;

/** The title and the price banner under it, on a tighter gap so the banner stays attached to the
 *  title it explains. */
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

/** The form heading; its own bottom margin zeroed because Header's gap owns that space. */
export const FormTitle = styled(SectionTitle)`
  margin-bottom: 0;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

/** Cancel on the left, Create on the right. */
export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${SPACE[12]};
  flex-wrap: wrap;
`;
